import type { IProfileService } from "App/Modules/Auth";
import type { IProfile } from "App/Modules/Models";

export class ProfileComponentController {
    public static $inject = ["mmProfileService"];

    public profile: IProfile;

    constructor(private readonly profileService: IProfileService) {
        profileService.profileObservable().subscribe((profile) => {
            this.profile = profile;
        });
    }
}
